module.exports = __webpack_public_path__ + "static/media/businessReg.9f36bdb5.svg";